<template>
  <transition name="fade">
    <div
      v-if="showNotice"
      class="relative flex pr-2 py-4"
      :class="getBoxClass"
    >
      <div
        class="w-0 border-[2px] rounded-r-md mr-4"
        :class="getBorderClass"
      />
      <div class="flex justify-between">
        <div
          class="flex"
          :class="showIcon ? 'space-x-3' : 'space-x-1'"
        >
          <div class="shrink-0">
            <fa
              v-if="showIcon"
              aria-hidden="true"
              :icon="icon"
              class="text-xl fa-fw mt-1"
              :class="getIconClass"
            />
          </div>
          <div class="text-neutral-950 font-normal mt-0.5">
            <slot />
          </div>
        </div>

        <!-- Dismiss button -->
        <div
          v-if="showDismiss"
          class="ml-auto pl-3"
        >
          <div class="-mx-1.5 -my-1.5">
            <button
              :aria-label="$t('common.dismiss')"
              class="inline-flex p-1.5 focus:outline-none"
              type="button"
              @click="hideNotice"
            >
              <fa
                aria-hidden="true"
                :icon="['fal', 'xmark']"
                class="text-base fa-fw"
                :class="getIconClass"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'VetsterNotice',

  props: {
    icon: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: 'rust',
    },
    showDismiss: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showNotice: true,
    };
  },

  computed: {
    showIcon() {
      return this.icon.length > 0;
    },
    getBorderClass() {
      switch (this.color) {
        case 'blue':
          return 'border-blue-900';
        case 'green':
          return 'border-green-600';
        case 'pink':
          return 'border-bubblegum-500';
        case 'purple':
          return 'border-grimace-800';
        case 'ocean':
          return 'border-ocean-700';
        case 'yellow':
          return 'border-yellow-500';
        case 'red':
        case 'rust':
        default:
          return 'border-red-600';
      }
    },
    getBoxClass() {
      switch (this.color) {
        case 'blue':
          return 'bg-blue-50';
        case 'green':
          return 'bg-green-50';
        case 'pink':
          return 'bg-bubblegum-50';
        case 'purple':
          return 'bg-grimace-50';
        case 'ocean':
          return 'bg-ocean-50';
        case 'red':
          return 'bg-red-50';
        case 'yellow':
          return 'bg-yellow-50';
        case 'rust':
        default:
          return 'bg-rust-50';
      }
    },
    getIconClass() {
      switch (this.color) {
        case 'blue':
          return 'text-blue-900';
        case 'green':
          return 'text-green-600';
        case 'pink':
          return 'text-bubblegum-500';
        case 'purple':
          return 'text-grimace-800';
        case 'ocean':
          return 'text-ocean-950';
        case 'yellow':
          return 'text-yellow-500';
        case 'rust':
        default:
          return 'text-red-600';
      }
    },
  },

  methods: {
    hideNotice() {
      this.showNotice = false;
      this.$emit('hide');
    },
  },
};
</script>
